const styles = (theme) => ({
  root: {
    '& .CardContent': {
      paddingBottom: theme.spacing.unit * 3,
    },
  },
  issueDetails: {
    paddingBottom: theme.spacing.unit,
  },
  hotspot: {
    cursor: 'pointer',
  },
  negativeTopMargin: {
    // Use negative margin to counter-act the displacement caused by the avatar
    [theme.breakpoints.up('md')]: {
      marginTop: '-30px',
    },
  },
  turquoise: {
    '&&': {
      color: theme.palette.custom.maintenance,
    },
  },
  subtitle: {
    width: 'calc(100% - 40px)',
  },
  icon: {
    color: theme.palette.custom.maintenance,
    paddingBottom: '2px',
    [theme.breakpoints.up('md')]: {
      marginTop: '10px',
      paddingBottom: '10px',
    },
  },
  nonCollapsedGrid: {
    paddingBottom: theme.spacing.unit,
    cursor: 'pointer',
  },
  nonCollapsedGridExpanded: {
    paddingBottom: theme.spacing.unit * 2,
    cursor: 'pointer',
  },
  bold: {
    fontWeight: 500,
  },
  collapsedGrid: {
    paddingBottom: theme.spacing.unit,
  },
  detailsDivider: {
    '&:last-child': {
      display: 'none',
    },
  },
  buttonContainerTop: {
    position: 'absolute',
    top: theme.spacing.unit * 1,
    right: theme.spacing.unit * 2,
    [theme.breakpoints.up('md')]: {
      top: theme.spacing.unit * 2,
    },
  },
  buttonContainerBottom: {
    border: `1px solid ${theme.palette.primary.dark}`,
    borderRadius: 5,
    position: 'absolute',
    bottom: theme.spacing.unit * -4,
    right: theme.spacing.unit * 2,
    [theme.breakpoints.up('md')]: {
      bottom: theme.spacing.unit * 2,
    },
  },
  removeIcon: {
    padding: 2,
  },
  actionIcon: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: theme.palette.primary.dark,
    borderRadius: '5px',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.text.white,
    },
  },
});

export default styles;
